// Centralized background colors for FirstLook slides
export const SLIDE_BACKGROUND_COLORS = {
  intro: '#DFF7EB',
  overview: '#E6F3FA',
  mss: '#F7F8F3',
  gutType: 'white',
  microbiomeBreakdown: 'white',
  microbiomeCategories: '#F7F8F3',
  microbiomeHealthScores: '#F7F8F3',
  topThreeIntro: '#DFF7EB',
  topThreeItem: 'var(--warm-grey-100)',
  conditions: '#F9EDE0',
  conditionsIntro: '#ECEBFF',
  conditionSpotlight: '#F9EDE0',
  dontWorry: '#E6F3FA',
  actionPlan: '#F2E587',
  actionPlanDietary: '#DFF7EB',
  actionPlanLifestyle: '#E6F3FA',
  actionPlanSupplements: '#EBEEFF',
  retestPrompt: '#F7F8F3',
  end: '#CDEAFA',
} as const;
